import posthog from "posthog-js"

posthog.init(import.meta.env.REACT_APP_POSTHOG_API_KEY, {
  api_host: import.meta.env.REACT_APP_POSTHOG_API_HOST,
  ui_host: "https://eu.posthog.com",
  feature_flag_request_timeout_ms: 1000,
  bootstrap: {
    featureFlags: {},
  },
})

// Dev-only escape hatch so feature flags can be overridden from the console:
// posthog.featureFlags.overrideFeatureFlags({flags: {"some-flag": true}})
if (import.meta.env.DEV) {
  ;(window as unknown as { posthog: typeof posthog }).posthog = posthog
}
